﻿let UserSession = require('./UserSession');
let FillLoginData = require('./FullDonationForm/FillLoginData');

//check if Create ActionResult is called
$(function () {

    var waitingForResponse = false;
    var errorField = $('.login-error-field .error-text');
    var cancelButton = $('#cancel-login');
    let userSession = new UserSession();
    var ifLoginInDonationForm = $('.full-donation-form .login-widget-wrapper').length;
    var emailNameMatchingError = $('.error-name-not-matching');


    cancelButton.on('click', function (e) {
        e.preventDefault();
        window.location.replace(jnfroutesconfg.ServerUrl);
    });

    $("#login").on('click submit', function (e) {
        e.preventDefault();
        var loginButton = $(this);
        if ($("#emailValue").valid() && $("#passwordValue").valid()) {
            waitingForResponse = true;
            loginButton.html('<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>').addClass('sending-request');

            var password = $("#passwordValue").val();
            var email = $("#emailValue").val();
            var loginData = {
                Email: email,
                Password: password
            }

            userSession.signIn(loginData)
                .then(() => {
                    if (!ifLoginInDonationForm) {
                        window.location.href = REDIRECTURL;
                    }
                    else {
                        FillLoginData(email);
                        emailNameMatchingError.css('display', 'none');
                    }

                }).catch(error => {
                    if (error.Result === 3) {
                        errorField.html("Wrong username or password.");
                    } else {
                        errorField.html("An error has occured. Try again later.");
                    }
                }).finally(() => {
                    loginButton.html('SUBMIT').removeClass('sending-request');

                }).done();
        }
    });
});
